import Emblem from './Emblem';

export default Emblem;
